// extracted by mini-css-extract-plugin
export var alignCenter = "_aj-d";
export var bannerShown = "_aj-6";
export var buttonContent = "_aj-0";
export var cardList = "_aj-1";
export var centerContent = "_aj-2";
export var chevron = "_aj-3";
export var closePanelButton = "_aj-k";
export var conversationContextContainer = "_aj-l";
export var conversationDetailContainer = "_aj-4";
export var detailWrapper = "_aj-7";
export var dropdownButton = "_aj-e";
export var dropdownTitle = "_aj-9";
export var fullHeight = "_aj-5";
export var hidden = "_aj-a";
export var icon = "_aj-b";
export var mergeSuggestionWrapper = "_aj-m";
export var panel = "_aj-i";
export var portalButtonsWrapper = "_aj-c";
export var right = "_aj-j";
export var tableSummaryContainer = "_aj-8";
export var tableSummaryHeader = "_aj-g";
export var threeDotsButton = "_aj-f";
export var wide = "_aj-h";